
'use strict';

import {FooterContactTabView} from './FooterContactTabView';
let contactTabView;

var Footer = function() {
  if (contactTabView) return;
  contactTabView = new FooterContactTabView({
    el: '#footer-contact-tab'
  });
};

Footer.create = function($parent) {
  $parent.find('footer.Footer').each(function(n, el) {
    new Footer(el);
  });
};

module.exports = Footer;


// WEBPACK FOOTER //
// ./assets/components/Footer/Footer.js